import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
}

/**
 * 动态设置页面标题、描述、关键词与 Canonical 规范网址。
 * 由后端注入的 __BASE_PATH__ 处理部署子路径。
 */
export function useSeo({ title, description, keywords, canonicalPath = "/" }: SeoOptions) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? "property" : "name";
      let el = document.head.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);

    const basePath = __BASE_PATH__.split("/").filter(Boolean).join("/");
    const pathPrefix = basePath ? `/${basePath}` : "";
    const canonical = `https://panelpeek.github.io${pathPrefix}${canonicalPath}`;
    setMeta("robots", "index, follow");
    setMeta("og:title", title, true);
    setMeta("og:description", description, true);
    setMeta("og:url", canonical, true);
    setMeta("twitter:title", title, true);
    setMeta("twitter:description", description, true);

    let canonicalEl = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonicalEl) {
      canonicalEl = document.createElement("link");
      canonicalEl.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.setAttribute("href", canonical);
  }, [title, description, keywords, canonicalPath]);
}